module.exports = __webpack_public_path__ + "img/ico-profile-default.7d7b3917.svg";